import React from 'react';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { contact } from 'settings';
// import Taren from 'assets/images/taren.jpg';

const crumbRoutes = {
  '/main': 'Home',
  '/main/sell': 'Sell',
  '/main/sell/contact': 'Contact',
};

const ContactView = () => (
  <span>
    <div className="contentContainer contact">
      <div className="contactView">
        <div className="card">
          <div className="contactView__Header" />
          <div className="contactView__Content">
            <div>{contact.image && <img src={contact.image} alt={contact.organisation} />}</div>
            <h1>Tauck</h1>
            <p>
              <FontAwesomeIcon icon={['fas', 'envelope']} />
              10 Westport Road Wilton, CT 06897
            </p>
            <p>
              <FontAwesomeIcon icon={['fas', 'phone']} /> 800-468-2825
            </p>
            <p>
              <FontAwesomeIcon icon={['fas', 'fax']} /> 203-899-6600
            </p>
            <p>
              <a href="mailto:info@tauck.com">
                <FontAwesomeIcon icon={['fas', 'envelope']} /> info@tauck.com
              </a>
            </p>
            <p>
            <a href="http://tauck.com" target="_blank">
              <FontAwesomeIcon icon={['fas', 'link']} />
              https://www.tauck.com
            </a>
            </p>
            <hr />
            <br />
            <p>Inside Sales:</p>
            <p>
              <a href="mailto:info@tauck.com">
                <FontAwesomeIcon icon={['fas', 'envelope']} /> salesteam@tauck.com
              </a>
            </p>
            <p>
              <FontAwesomeIcon icon={['fas', 'phone']} /> 203-899-6500 x4988
            </p>
          </div>
        </div>
      </div>
    </div>
  </span>
);

export default ContactView;
